<template>
  <div class="check-item-renderer">
    <ul>
      <li>{{ $t('Message.Problem') }}</li>
      <li>{{ $t('CargoMsg.Cargo_Describe') }}</li>
      <li />
    </ul>
    <div v-for="(item,index) in showData" :key="index" class="item-check-warp">
      <div>
        <el-tooltip effect="dark" :content="`${item.lbTxt}`" placement="bottom-start">
          <label>{{ item.lbTxt }}</label>
        </el-tooltip>
      </div>
      <div v-if="item.child.length > 0">
        <div v-for="(list,keys) in item.child" :key="list+keys">
          <span class="info">{{ list.lbTxt }}</span>
          <img :src="icon(list)" :class="list.state === 'checking' ? 'animate' : ''">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  JOB,
  LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE,
  MBL_CANNOT_REPEATED,
  USER,
  USER_REQUIRES
} from '@/class/cargo/model/parameters/CheckRuleConstants'

const states = {
  checking: 'checking',
  success: 'success',
  warning: 'warning',
  failure: 'failure',
  node: 'node'
}
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { LOCAL_SERVICES_TYPE } from '@/class/cargo/model/parameters/SystemConstants'
import acceptIcon from '@/assets/accept-x16.png'
import warningIcon from '@/assets/warning-x16.png'
import loadingIcon from '@/assets/loading-x32.png'
import rejectIcon from '@/assets/reject-x16.png'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'CheckItemRenderer',
  props: {
    data: { type: Array, default: () => { return [] } },
    dataType: { type: String, default: () => JOB.code }
  },
  data() {
    return {
      states,
      showData: [] // 用于界面显示的数据
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$logger.log('data', this.data)
      this.data.map(item => {
        if (item['type'] === 'node') {
          item.lbTxt = item['name']
          item.currentState = 'node'
        } else {
          let state
          if (USER.code === this.dataType) {
            state = CommonState.getStateByCode(CheckRuleConstants.USER_REQUIRES, item['name'])
          } else {
            state = CommonState.getStateByCode(CheckRuleConstants.EXPRESSION_DIMENSIONS, item['name'])
          }
          let name = state === null ? item['name'] : (this.$store.getters.language === 'zh' ? state.chineseName : state.englishName)

          if (item['node']['checkCategory'] !== CheckRuleConstants.CATEGORY_DATA_LOGIC.code) {
            const operator = CommonState.getStateByCode(CheckRuleConstants.ALL_OPERATOR, item['operator'])
            name += operator ? (this.$store.getters.language === 'zh' ? operator.chineseName : operator.englishName) : ''
            if (item['name'] === CheckRuleConstants.REQUIRE_USER_DEFINED_ROLE_ID1.code || item['name'] === CheckRuleConstants.REQUIRE_USER_DEFINED_ROLE_ID2.code) {
              name += this.convertUserIdsLabel(item['value'])
            } else {
              name += item['value']
            }
          } else if (item['node']['checkCategory'] === CheckRuleConstants.CATEGORY_DATA_LOGIC.code) {
            if (item['name'] === CheckRuleConstants.LOGIC_DYNAMIC_FILE_TYPE.code || item['name'] === CheckRuleConstants.LOGIC_WAREHOUSE_NO.code ||
              item['name'] === CheckRuleConstants.CHARGEABLE_WEIGHT_RT.code || item['name'] === CheckRuleConstants.MBL_CANNOT_REPEATED.code ||
              item['name'] === CheckRuleConstants.LOGIC_SENSITIVE_WORD_ENGLISH_NAME.code || item['name'] === CheckRuleConstants.LOGIC_SENSITIVE_WORD_CHINESE_NAME.code ||
              item['name'] === CheckRuleConstants.LOGIC_SENSITIVE_WORD_MARK.code || item['name'] === CheckRuleConstants.LOGIC_AR_CHARGE_LOCAL_TOTAL.code ||
              item['name'] === CheckRuleConstants.LOGIC_AP_CHARGE_LOCAL_TOTAL.code || item['name'] === CheckRuleConstants.LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE.code ||
              item['name'] === CheckRuleConstants.LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE.code ||
              item['name'] === CheckRuleConstants.LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE.code ||
              item['name'] === CheckRuleConstants.LOGIC_APPLICATION_STATUS_FOR_RELEASE.code) {
              if (item['name'] === CheckRuleConstants.CHARGEABLE_WEIGHT_RT.code) {
                name = (this.$store.getters.language === 'zh' ? CheckRuleConstants.CHARGEABLE_WEIGHT_RT.chineseName : CheckRuleConstants.CHARGEABLE_WEIGHT_RT.englishName)
              }
              if (item['name'] === CheckRuleConstants.MBL_CANNOT_REPEATED.code) {
                name = (this.$store.getters.language === 'zh' ? CheckRuleConstants.MBL_CANNOT_REPEATED.chineseName : CheckRuleConstants.MBL_CANNOT_REPEATED.englishName)
              }
              const operator = CommonState.getStateByCode(CheckRuleConstants.ALL_OPERATOR, item['operator'])
              name += operator ? (this.$store.getters.language === 'zh' ? operator.chineseName : operator.englishName) : ''
              if (item['name'] === CheckRuleConstants.LOGIC_APPLICATION_STATUS_FOR_RELEASE.code) {
                name += item['value'] === 0 ? (this.$store.getters.language === 'zh' ? CheckRuleConstants.LOGIC_NOT_APPLIED.chineseName : CheckRuleConstants.LOGIC_NOT_APPLIED.englishName)
                  : (this.$store.getters.language === 'zh' ? CheckRuleConstants.LOGIC_APPLIED.chineseName : CheckRuleConstants.LOGIC_APPLIED.englishName)
              } else {
                name += item['value']
              }
            } else if (item['name'] === CheckRuleConstants.LOGIC_LOCAL_SERVICES.code) {
              const operator = CommonState.getStateByCode(CheckRuleConstants.ALL_OPERATOR, item['operator'])
              name += operator ? (this.$store.getters.language === 'zh' ? operator.chineseName : operator.englishName) : ''
              const itemValue = [...LOCAL_SERVICES_TYPE].find(p => p.code === item['value'])
              name += itemValue ? itemValue.chineseName : ''
            } else if (item['name'] === CheckRuleConstants.LOGIC_CONSIGNATION_COMPANY_SCOPE.code || item['name'] === CheckRuleConstants.LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE.code) {
              const operator = CommonState.getStateByCode(CheckRuleConstants.ALL_OPERATOR, item['operator'])
              name += operator ? (this.$store.getters.language === 'zh' ? operator.chineseName : operator.englishName) : ''
              name += this.convertCmpIdsLabel(item['value'])
            } else if (item['name'] === CheckRuleConstants.SALES_AND_OPERATIONS_DIFFER.code) {
              name = (this.$store.getters.language === 'zh' ? SystemConstants.SALES_AND_OPERATIONS_ARE_THE_SAME.chineseName : SystemConstants.SALES_AND_OPERATIONS_ARE_THE_SAME.englishName)
            }
          }
          item.lbTxt = item.customDescription || name
          if (item['checking'] === true) {
            item.currentState = 'checking'
          } else if (item['match'] === true) {
            item.currentState = 'success'
          } else if (item['node']['checkMode'] === CheckRuleConstants.MODE_WARNING.code) {
            item.currentState = 'warning'
          } else {
            item.currentState = 'failure'
          }
        }
      })
      this.handleDataShow(this.data)
    },
    handleDataShow(data) {
      const result = []
      data.map(element => {
        if (element.type === 'node') {
          element.child = []
          result.push(element)
        }
      })

      if (result.length > 0) {
        result.map(eve => {
          data.map(e => {
            if (e.type !== 'node') {
              if (e.node.lbTxt === eve.lbTxt) {
                eve.child.push(e)
              }
            }
          })
        })
      }
      this.showData = result
    },
    icon(item) {
      let iconImg = ''
      switch (item.currentState) {
        case states.checking:
          iconImg = loadingIcon
          break
        case states.success:
          iconImg = acceptIcon
          break
        case states.warning:
          iconImg = warningIcon
          break
        case states.failure:
          iconImg = rejectIcon
          break
      }
      return iconImg
    },
    convertUserIdsLabel(userIds) {
      if (userIds) {
        return Array.from(userIds.split(','), p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(p), 'chineseName')).join(',')
      }
      return ''
    },
    convertCmpIdsLabel(cmpIds) {
      if (cmpIds) {
        return Array.from(cmpIds.split(','), p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(p), 'chineseName')).join(',')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.check-item-renderer{
  ul{
    margin: 0 0 10px 0;
    height: 32px;
    background-color: #F2F2F2;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-inline-start: 0;
    li{
      list-style: none;
      text-align: left;
      color: #000;
      font-size: 14px;
      font-weight: bold;
      &:first-of-type{
        width: 40%;
        text-align: center;
      }
      &:nth-of-type(2){
        width: 40%;
      }
    }
  }
  .item-check-warp{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    > div{
      width: 60%;
      line-height: 30px;
      font-size: 14px;
      color: #000;
      font-weight: bold;
      cursor: default;
      &:first-of-type{
        width: 40%;
        padding: 0 1%;
        box-sizing: border-box;
        overflow: hidden;
        white-space:nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
      .info{
        width: 78%;
        display: inline-block;
        font-size: 14px;
        font-weight: normal;
      }
      img{
        vertical-align:  middle;
      }
    }
    .animate{
      animation: loadingAnimation 2s infinite;
      -webkit-animation: loadingAnimation 2s infinite;
      -moz-animation: loadingAnimation 2s infinite;
      -o-animation: loadingAnimation 2s infinite;
    }
  }
}

@keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}

@-moz-keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}

@-o-keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>
